/**
 * De enum die het viewertype aangeeft TWEE_D (default = ol) of DRIE_D (cesium).
 */
export enum ViewerType {
  DRIE_D = "3D",
  TWEE_D = "2D"
}
